/* unplugin-vue-components disabled */import script from "./UserTag.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTag.vue?vue&type=script&setup=true&lang=js"

import "./UserTag.vue?vue&type=style&index=0&id=293f534b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-293f534b"]])

export default __exports__